import { aboutPoints, testimonials } from '@/mocks/manhwa';

export default function About() {
  const points = aboutPoints;
  return (
    <section id="about" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">关于漫画韩国下拉式</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              漫画韩国下拉式是一个专注韩漫阅读与追更的中文门户。我们与多家优秀汉化组保持长期合作，把最新鲜的熟肉连载第一时间带给每一位韩漫爱好者。坚持"一话到底"的下拉式阅读体验，让追更更流畅、更沉浸、更舒服。
            </p>

            <div className="mt-7 grid gap-4 sm:grid-cols-2">
              {points.map((title, i) => {
                const desc = points[i + 1];
                if (i % 2 !== 0) return null;
                return (
                  <div key={title} className="flex gap-3 rounded-lg bg-background-50 p-4">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                      <i className={i === 0 ? 'ri-community-fill' : 'ri-slideshow-3-fill'} />
                    </span>
                    <div>
                      <h3 className="font-bold text-foreground-950">{title}</h3>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">{desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="flex justify-center">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20cozy%20reading%20nook%20with%20a%20tablet%20displaying%20a%20colorful%20manhwa%20page%2C%20warm%20lamp%20glow%2C%20books%20and%20snacks%20nearby%2C%20relaxed%20evening%20atmosphere%2C%20warm%20cream%20and%20coral%20palette%2C%20clean%20flat%20style%2C%20no%20text&width=720&height=520&seq=about-scene&orientation=landscape"
              alt="漫画韩国下拉式沉浸式阅读场景插画"
              className="w-full max-w-lg rounded-lg object-cover"
            />
          </div>
        </div>

        <div className="mt-14">
          <h3 className="mb-6 text-center font-heading text-xl text-foreground-950 md:text-2xl">读者口碑</h3>
          <div className="grid gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-lg bg-background-50 p-5">
                <div className="flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={`${t.name} 的读者头像`}
                    className="h-10 w-10 rounded-full object-cover"
                  />
                  <figcaption>
                    <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </figcaption>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.content}”</blockquote>
                <div className="mt-3 flex gap-0.5 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs" />
                  ))}
                </div>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}